module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMTIgNiI+PHBhdGggZmlsbD0iIzAwOUIzQSIgZD0iTTAgMGgxMnY2SDAiLz48cGF0aCBzdHJva2U9IiNGRUQxMDAiIGQ9Ik0tNiA5TDE4LTNWOUwtNi0zIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/jam.svg
// module id = Rq12
// module chunks = 0